<nav class="side-navbar scrollbar-y" [ngClass]="{ shrinked: sidebar_active }">
    <!-- Sidebar Header-->
    <ul
        class="list-unstyled pb-0 m-0"
        style="position: relative"
        *ngIf="authService.isLogged">
        <ngx-spinner
            name="sidebar"
            [fullScreen]="false"
            type="ball-scale-multiple"></ngx-spinner>
        <li>
            <a href="#dd_teste" aria-expanded="false" data-toggle="collapse">
                <span class="h5 m-0 text-bold text-wrap" style="width: 95%">{{
                    colaborador?.nome
                }}</span>
            </a>
            <ul id="dd_teste" class="collapse list-unstyled">
                <li>
                    <a
                        class="d-flex"
                        routerLink="/colaborador/user/edit"
                        routerLinkActive="collapse-active"
                        >Alterar senha</a
                    >
                </li>
            </ul>
        </li>
    </ul>
    <hr class="m-0 mt-1" />
    <!-- Sidebar Navigation Menus-->
    <div id="collapseGroup">
        <ul class="list-unstyled">
            <li *ngFor="let item of links">
                <a
                    data-menu="main"
                    [href]="'#dd_' + item.id"
                    aria-expanded="false"
                    data-toggle="collapse"
                    #item.menu>
                    <span
                        class="bg-danger border border-light rounded-circle p-1 float-right mr-4 my-2"
                        *ngIf="item.warn"></span>
                    {{ item.menu }}
                </a>
                <ul [id]="'dd_' + item.id" class="collapse list-unstyled">
                    <li *ngFor="let submenu of item.submenus">
                        <a
                            *ngIf="!submenu.submenus"
                            class="d-flex"
                            [routerLink]="submenu.href"
                            [queryParams]="submenu.query"
                            routerLinkActive="collapse-active"
                            (click)="onSelect()"
                            >{{ submenu.title }}
                            <div class="ml-1" [innerHTML]="submenu.badge"></div
                        ></a>
                        <a
                            *ngIf="submenu.submenus"
                            [href]="'#dd_' + submenu.id + '_lvl1'"
                            aria-expanded="false"
                            data-toggle="collapse"
                            #submenu.menu>
                            <span
                                class="bg-danger border border-light rounded-circle p-1 float-right mr-4 my-2"
                                *ngIf="submenu.warn"></span>
                            {{ submenu.menu }}
                        </a>
                        <ul
                            *ngIf="submenu.submenus"
                            [id]="'dd_' + submenu.id + '_lvl1'"
                            class="collapse list-unstyled">
                            <li *ngFor="let lvl1 of submenu.submenus">
                                <a
                                    class="d-flex"
                                    [routerLink]="lvl1.href"
                                    [queryParams]="lvl1.query"
                                    routerLinkActive="collapse-active"
                                    (click)="onSelect()"
                                    >{{ lvl1.title }}
                                    <div
                                        class="ml-1"
                                        [innerHTML]="lvl1.badge"></div
                                ></a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>
<sume-seletor-projetos></sume-seletor-projetos>
